<template>
  <SSection
    v-for="(card, index) in items"
    :key="index"
    :title="card.title"
    :centered="true"
    :has-separator="false"
  >
    <template #no-container>
      <SCardsImages
        :items="card.cards"
        @button-click="buttonClick($event, index)"
      />
      <TContainer v-if="card.button" class="my-5">
        <UButton
          :ui="mobileFullWidthButton"
          color="neutral"
          variant="subtle"
          size="lg"
          :label="card.button.text"
          :to="card.button.url"
          external
        />
      </TContainer>
    </template>
  </SSection>
</template>
<script setup lang="ts">
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface itemInterface {
  title?: string
  cards: {
    url: string
    image: string
    title: string
  }[]
  button?: {
    url: string
    text: string
  }
}

export interface propsInterface {
  items: itemInterface[]
}

defineProps<propsInterface>()
const emit = defineEmits<{
  (event: 'button-click', $event: Event, index: number): void
}>()

const buttonClick = (event: Event, index: number) => {
  emit('button-click', event, index)
}
</script>
